<template>
  <a
    href="javascript:;"
    :class="className"
    :r-eid="rEid"
    @click="click"
  >
    <slot><span>按钮</span></slot>
  </a>
</template>

<script>
  export default {
    name: 'k-btn',
    props: ['type', 'eid', 'name', 'skin', 'shape', 'size', 'disabled'],
    computed: {
      className() {
        const {type, name, skin, shape, size, disabled} = this;
        const base = type ? type : 'k-btn';
        const c = [base];
        if(name) {
            c.push(`${base}-${name}`);
        }
        // TODO: 检测skin, size, shape的合法名称
        if(shape) {
            c.push(`${base}--${shape}`);
        }
        // danger, warn, 
        if(skin) {
            c.push(`${base}--${skin}`);
        }
        // l, m, s, lg, sm, xs, xl, xxl
        if(size) {
            c.push(`${base}--${size}`);
        }
        if(this.disabled === true) {
            c.push('disabled');
        }
        return c.join(' ');
      },
      rEid() {
        return this.eid ? this.eid : '';
      }
    },
    methods: {
      click(e) {
        if(this.disabled !== true) {
            this.$emit('click', e);
        }
      }
    }
  };
</script>
